import { render, staticRenderFns } from "./AnnualReturnsEscalatedFile.vue?vue&type=template&id=3d61f218&scoped=true&"
import script from "./AnnualReturnsEscalatedFile.vue?vue&type=script&lang=js&"
export * from "./AnnualReturnsEscalatedFile.vue?vue&type=script&lang=js&"
import style0 from "./AnnualReturnsEscalatedFile.vue?vue&type=style&index=0&id=3d61f218&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d61f218",
  null
  
)

export default component.exports